<template>
    <div>
        <div class="modal" :class="'is-active'">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Transactions</p>
                    <button class="delete" aria-label="close" @click="closeModal"></button>
                </header>

                <section class="modal-card-body">
                    <p class="has-text-success" v-if="getSuccess">{{ paymentMsg }}</p>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="no-wrap">Add Deposits</label>
                        </div>
                        <div class="field-body mr-10 mbr-0">
                            <div class="field">
                                <p class="control is-expanded ">
                                    <input v-model="paypalAmount" class="input" type="number"
                                           placeholder="Amount">

                                </p>
                            </div>
                        </div>
                        <div class="field-submit">
                            <div ref="paypal"></div>
                        </div>
                    </div>
                    <table class="table is-striped is-narrow is-hoverable is-fullwidth">
                        <thead>
                        <tr>
                            <th>Transaction</th>
                            <th>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colspan="2" class="has-text-centered">Coming soon...</td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="closeModal">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import PayPal from 'vue-paypal-checkout'

    export default {
        components: {
            PayPal

        },
        data() {
            return {
                modalStatus: false,
                paypalAmount: '',
                paypalCurrency: 0,
                paymentMsg: '',
                paypalClient: {
                    sandbox: 'ASqta9ZOOfiQLr_z4iniwYPJvsJ1Atk45zd82fTaI023ND8I9u5pBKvBi60QImFcob1V6dxfQBq7-qvY',
                    production: 'AaxhtJJA0nr5yaI-6GppVrCVqTCDWt_8sqGPio39eabV5HVKH2tqHBb5FX0up_GYaUwFMVG9oG-f1Kxu'
                }
            }
        },
        computed: {
            getCurrentUserCreditAmount() {
                return this.$store.getters.getCurrentUserCreditAmount
            },
            getCurrentUserDeposit() {
                return this.$store.getters.getUserDeposit
            },
            getCurrentUserDepositRate() {
                return this.$store.getters.getUserDepositRate == 1 ? '¥' : '$'
            },
            getCurrentUserRate() {
                return this.$store.getters.getUserDepositRate
            },
            getCurrentUserDueAmount() {
                return this.$store.getters.getUserDueAmount
            },
            isActived() {
                return this.modalStatus
            },
            getSuccess(){
                return this.$store.getters.getPaymentData
            }
        },
        methods: {
            openModal() {
                this.modalStatus = true
            },
            closeModal() {
                this.modalStatus = false
                this.$store.dispatch('openPaypal', false)
            },
            setLoaded: function() {
                this.loaded = true;

                window.paypal
                    .Buttons({
                        createOrder: (data, actions) => {
                            console.log(this.paypalAmount+"="+this.paypalCurrency)
                            if(this.paypalAmount) {
                                return actions.order.create({
                                    purchase_units: [
                                        {
                                            description: 'Deposits in UNET',
                                            amount: {
                                                currency_code: this.paypalCurrency == 1 ? 'JPY' : 'USD',
                                                value: this.paypalAmount
                                            }
                                        }
                                    ]
                                });
                            }
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            if(order){
                                this.$store.dispatch('payment', order);

                                this.paypalAmount = '';
                                this.paymentMsg = 'Payment Successful';
                                console.log(order);
                            }
                        },
                        onError: err => {
                            console.log(err);
                        }
                    })
                    .render(this.$refs.paypal);
            }
        },
        created() {
            this.paypalCurrency = this.$store.getters.getUserDepRate;
            const script = document.createElement("script");
            script.src =
                "https://www.paypal.com/sdk/js?currency="+(this.paypalCurrency == 1 ? 'JPY' : 'USD')+"&disable-funding=credit,card&client-id="+this.paypalClient.sandbox;
            script.addEventListener("load", this.setLoaded);
            document.body.appendChild(script);
        }
    }
</script>

<style scoped>
    span {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/Navigation/PaypalDeposit.vue